<template>
  <div v-if="images.length">
    <b-carousel
      :autoplay="false"
      :indicator="collection.length > 1"
      :arrow="collection.length > 1"
      with-carousel-list>
      <b-carousel-item v-for="(media, index) in images" :key="index">
        <figure class="image">
          <img :src="media.image" />
          <p>
            {{ media.caption }} <br/>
          </p>
        </figure>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import { imageUrl } from '@/utils/s3'
export default {
  props: {
    collection: Array
  },
  data () {
    return {
      images: []
    }
  },
  async created () {
    this.images = this.collection.map(i => {
      const image = imageUrl(i.key)
      return { ...i, image }
    })
  }
}
</script>
